<template>
    <div class="right-top-right">
        <el-dropdown  trigger="click"  @command="handleCommand" style="outline:none;border:none;overflow: hidden;">
            <div class="pointer" style="padding:5px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:#a6a6a6">
                关闭操作
                <i class="vxe-icon--caret-bottom" ></i>
            </div>
            <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="closeMe">关闭当前窗口</el-dropdown-item>
                <el-dropdown-item command="closeAll">关闭全部窗口</el-dropdown-item>
                
            </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link" style="color:#1781C9">
                当前用户：{{'用户名'}}
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="userInfo">账号信息</el-dropdown-item>
                <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <div style="color:#D43030" @click="logOut">
            退出
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{

        }
    },
    methods:{
        logOut(){
            this.$confirm('真的要退出系统吗？').then(()=>{
                localStorage.removeItem("agttoken");
                this.$router.replace("/");
            })
        },
        handleCommand(command) {
            this.$emit("getcommand", command);
            // if (command == "closeAll") {
            //     this.$confirm('真的要退出系统吗？').then(()=>{
            //         localStorage.removeItem("agttoken");
            //         this.$router.replace("/");
            //     })
                
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
    $pic_size: 22px;
    $font-color: #d3d3d3;
    $icon_size: 22px;
    
    .right-top-right{
        width: 350px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }
   
    /**设置字体颜色 */
    .el-dropdown {
        color: $font-color;
    }
    .content,
    .setting {
        white-space: nowrap;
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        div {
            font-size: 14px;
            font-weight: 100;
        }
    }
    .setting img {
        width: $icon_size;
        height: $icon_size;
    }
    /**图片 */
    .headerPic {
        width: $pic_size;
        height: $pic_size;
        border-radius: 100px;
        margin-right: 2px;
    }
    .settingList {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        img {
            margin-right: 2px;
        }
    }
    .el-dropdown-link {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }
    .pointer{
        cursor:pointer
    }
    .row{
        display: flex;
        align-items:center;
    }
</style>


// WEBPACK FOOTER //
// src/components/topuser.vue